import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import { FeatureFlagCollection } from "./featureFlags";
import { FeatureFlagsLoaded, FeatureFlagUpdated } from "./featureFlags.actions";

export default class FeatureFlagReducer extends ReducerBase<FeatureFlagCollection> {

    constructor() {
        super();
        this.addHandler(FeatureFlagsLoaded.EventName, this.handleFeatureFlagsLoaded);
        this.addHandler(FeatureFlagUpdated.EventName, this.handleFeatureFlagUpdated);
    }

    handleFeatureFlagsLoaded(state: FeatureFlagCollection = initialState.featureFlags, event: FeatureFlagsLoaded): FeatureFlagCollection {
        return event.featureFlags;
    }

    handleFeatureFlagUpdated(state: FeatureFlagCollection, event: FeatureFlagUpdated): FeatureFlagCollection {
        const flags = { ...state };
        
        flags[event.flag] = { ...flags[event.flag], currentValue: event.value };

        return flags;
    }

    handleDefault(state: FeatureFlagCollection = initialState.featureFlags): FeatureFlagCollection {
        return state;
    }
}